/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class AppService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Health check
     * Returns a hello message to verify the API is running.
     * @returns string API is running successfully.
     * @throws ApiError
     */
    public appControllerGetHello(): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api',
        });
    }
    /**
     * Download gRPC proto file
     * Downloads the WiSecure gRPC proto definition file. Use this to generate client stubs for any language (Dart, Go, etc.).
     * @returns any Proto file downloaded successfully.
     * @throws ApiError
     */
    public appControllerGetProto(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/proto/wisecure.proto',
            errors: {
                404: `Proto file not found.`,
            },
        });
    }
}
